export default __webpack_public_path__ + "static/surfers-2d084af242cae818f272b474c58e8cd7.jpg";